import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { getData, postData } from 'src/utils/axios/serverHelper';

import { TQC1040_R01Dto } from './Dto_TQC1040_R01';
import { TQC1040_R01Filter } from './Store_TQC1040_R01';

const baseUrl = `${config.apiUrl}/TQC1040_R01`;

export interface TQC1040_R01Params {
	compCd?: string;
	equipmentType?: string;
	equipmentCd?: string;
	startDate?: string;
	endDate?: string;
}

/** 입고 검사 대상 목록 조회 */
export const getTQC1040_R01List = async (
	option: string,
	params: TQC1040_R01Params,
) => {
	const url = option === 'search' ? `${baseUrl}/search` : baseUrl;
	return await getData<ResponseDto<TQC1040_R01Dto[]>>(url, { params });
};

/** 전체 건수 조회 */
export const getTQC1040_R01AllCount = async (params: TQC1040_R01Params) => {
	return await getData<ResponseDto<number>>(`${baseUrl}/allCount`, { params });
};

/** 검사 결과 일괄 저장 */
export const saveTQC1040_R01 = async (list: TQC1040_R01Dto[]) => {
	return await postData<TQC1040_R01Dto[], ResponseDto<number>>(`${baseUrl}/save`, list);
};

/** 약품 수입 검사대장 PDF */
export const downloadReportPdf_TQC1040_R01 = async (params: TQC1040_R01Params) => {
	return await getData<Blob>(`${baseUrl}/report/pdf`, {
		params,
		responseType: 'blob',
		headers: { Accept: 'application/pdf' },
	});
};

export type { TQC1040_R01Filter };
